import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface PlaceholderPageProps {
  titleKey: string;
  phase?: string;
}

export function PlaceholderPage({ titleKey, phase }: PlaceholderPageProps) {
  const { t } = useTranslation();
  return (
    <div className="max-w-2xl">
      <Card>
        <CardHeader>
          <CardTitle>{t(titleKey)}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-slate-500 text-sm">
            {phase ? t("app.in_development", { phase }) : t("app.placeholder")}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
